module.exports = __webpack_public_path__ + "img/poll-h.62030afb.svg";